import React from 'react';

import GameLink from './GameLink';
import { WorldDimentions } from '../types';
import { GamePositionModel } from '../../models/gamePositionModel';

interface Props extends WorldDimentions {
  gamePositions: GamePositionModel[],
  islandId: string;
  onHistoryPush: (route: string, state?: unknown) => void;
}

/**
 * A layer the size of the world on which the game links are being placed.
 */
const GameLayer = ({
  gamePositions = [], worldHeight, worldWidth, islandId, onHistoryPush,
}: Props): React.ReactElement => (
  <>
    {
      gamePositions.map((gamePosition) => (
        <GameLink
          key={gamePosition.id}
          islandId={islandId}
          gamePosition={gamePosition}
          worldWidth={worldWidth}
          worldHeight={worldHeight}
          onHistoryPush={onHistoryPush}
        />
      ))
    }
  </>
);

export default GameLayer;
